import { Navigate, useLocation, useSearchParams } from 'react-router-dom';

import { useCurrentUserContext } from '@sorare/core/src/contexts/currentUser';
import { useSportContext } from '@sorare/core/src/contexts/sport';
import { ENTER_FROM_ANDROID_MARKETPLACE_TAB_PARAM } from '@sorare/core/src/hooks/useIsMobileApp';
import { useEvents } from '@sorare/core/src/lib/events/useEvents';

export const EnterFromAndroidMarketPlaceTab = () => {
  const { currentUser } = useCurrentUserContext();
  const track = useEvents();
  const { sport } = useSportContext();
  const location = useLocation();
  const [searchParams] = useSearchParams();

  const originAppBuildVersion = searchParams.get(
    ENTER_FROM_ANDROID_MARKETPLACE_TAB_PARAM
  );

  if (!originAppBuildVersion) {
    return null;
  }

  track('Enter From Android Marketplace Tab', {
    appBuildVersion: originAppBuildVersion,
    sport,
    userSlug: currentUser?.slug,
  });

  searchParams.delete(ENTER_FROM_ANDROID_MARKETPLACE_TAB_PARAM);

  const cleanedParams = searchParams.toString();

  return (
    <Navigate
      to={{ pathname: location.pathname, search: cleanedParams }}
      replace
    />
  );
};
